module.exports = __webpack_public_path__ + "img/language.c01df086.png";